"use client";

import { Phone, Sparkles, Star, Heart, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourAscent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1191" id="start-your-ascent" className="dark bg-background text-foreground relative overflow-hidden" style={{
    backgroundColor: "hsl(225 73% 20%)"
  }}>
      {}
      <svg className="absolute top-0 left-0 w-full h-6 z-10" viewBox="0 0 1200 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 L40,18 L80,8 L120,16 L160,10 L200,20 L240,12 L280,18 L320,6 L360,16 L400,10 L440,20 L480,8 L520,14 L560,18 L600,10 L640,20 L680,12 L720,16 L760,8 L800,18 L840,10 L880,20 L920,12 L960,16 L1000,8 L1040,18 L1080,12 L1120,20 L1160,10 L1200,16 L1200,0 Z" fill="hsl(225 30% 8%)" />
      </svg>

      {}
      <svg className="absolute bottom-0 left-0 w-full h-6 z-10 rotate-180" viewBox="0 0 1200 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 L40,18 L80,8 L120,16 L160,10 L200,20 L240,12 L280,18 L320,6 L360,16 L400,10 L440,20 L480,8 L520,14 L560,18 L600,10 L640,20 L680,12 L720,16 L760,8 L800,18 L840,10 L880,20 L920,12 L960,16 L1000,8 L1040,18 L1080,12 L1120,20 L1160,10 L1200,16 L1200,0 Z" fill="hsl(0 0% 100%)" />
      </svg>

      {}
      <svg className="absolute top-16 left-4 md:top-24 md:left-16 w-20 h-20 md:w-32 md:h-32 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 10 L58 38 L88 42 L64 60 L72 88 L50 72 L28 88 L36 60 L12 42 L42 38 Z" stroke="hsl(0 0% 100%)" strokeWidth="4" strokeLinejoin="round" fill="none" />
      </svg>

      {}
      <svg className="absolute top-20 right-6 md:top-28 md:right-20 w-16 h-16 md:w-28 md:h-28 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 5 L50 35" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 65 L50 95" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M5 50 L35 50" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M65 50 L95 50" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M18 18 L38 38" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M62 62 L82 82" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M82 18 L62 38" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M38 62 L18 82" stroke="hsl(217 91% 60%)" strokeWidth="4" strokeLinecap="round" />
      </svg>

      {}
      <svg className="absolute bottom-20 right-4 md:bottom-28 md:right-16 w-20 h-20 md:w-32 md:h-32 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 20 C 30 20 20 35 20 50 C 20 65 35 75 50 75 C 60 75 70 70 70 60 C 70 52 64 48 58 48 C 52 48 48 52 48 58" stroke="hsl(225 30% 8%)" strokeWidth="4" strokeLinecap="round" fill="none" />
      </svg>

      {}
      <svg className="absolute bottom-16 left-6 md:bottom-24 md:left-20 w-16 h-16 md:w-28 md:h-28 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <circle cx="50" cy="50" r="40" stroke="hsl(0 0% 100%)" strokeWidth="4" fill="none" />
        <path d="M50 10 L50 90" stroke="hsl(0 0% 100%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 50 L20 78" stroke="hsl(0 0% 100%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 50 L80 78" stroke="hsl(0 0% 100%)" strokeWidth="4" strokeLinecap="round" />
      </svg>

      {}
      <div className="absolute top-2 left-4 md:top-4 md:left-12 z-20" style={{
      backgroundColor: "hsl(0 0% 100%)",
      border: "1px solid hsl(225 15% 90%)",
      borderRadius: "0px",
      padding: "0.5rem 1.25rem",
      color: "hsl(225 73% 20%)"
    }}>
        <span className="font-default text-sm md:text-base tracking-wide flex items-center gap-2">
          <Star className="w-4 h-4 fill-current" strokeWidth={3} />
          ELITE ACADEMIC SUPPORT
          <Zap className="w-4 h-4 fill-current" strokeWidth={3} />
        </span>
      </div>

      {}
      <Sparkles className="absolute top-32 left-1/4 w-8 h-8 opacity-50 pointer-events-none" style={{
      color: "hsl(0 0% 100%)"
    }} strokeWidth={3} aria-hidden="true" />
      <Heart className="absolute bottom-32 right-1/3 w-8 h-8 opacity-50 pointer-events-none" style={{
      color: "hsl(225 30% 8%)"
    }} strokeWidth={3} aria-hidden="true" />

      {}
      <div ref={ref} className="relative z-10 max-w-5xl mx-auto px-6 md:px-10 lg:px-16 py-32 md:py-44 text-center" style={{
      transform: isVisible ? "translateY(0)" : "translateY(24px)",
      opacity: isVisible ? 1 : 0,
      transition: "transform 600ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 600ms ease-out"
    }}>
        {}
        <p className="font-default uppercase font-black tracking-[0.18em] text-xs md:text-sm mb-6" style={{
        color: "hsl(0 0% 100%)"
      }}>
          STEM & Test Prep Mastery
        </p>

        {}
        <h1 className="font-default font-extrabold leading-[0.92] tracking-tight mb-8" style={{
        fontSize: "clamp(3.25rem, 8vw, 7.5rem)",
        color: "hsl(0 0% 100%)"
      }}>
          <span className="block">ARCHITECT YOUR</span>
          <span className="relative inline-block mt-2">
            <span className="relative z-10 px-4">ASCENT</span>
            {}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 300 140" preserveAspectRatio="none" aria-hidden="true" style={{
            overflow: "visible"
          }}>
              <path d="M150,12 C 70,14 18,38 14,72 C 12,108 78,128 152,128 C 232,128 290,108 288,72 C 286,38 224,16 150,12 Z" fill="none" stroke="hsl(217 91% 60%)" strokeWidth="6" strokeLinecap="round" style={{
              strokeDasharray: 800,
              strokeDashoffset: isVisible ? 0 : 800,
              transition: "stroke-dashoffset 900ms ease-out 400ms"
            }} />
            </svg>
          </span>
        </h1>

        {}
        <p className="font-default font-medium mx-auto max-w-2xl mb-10 md:mb-12" style={{
        fontSize: "clamp(1.0625rem, 1.4vw, 1.375rem)",
        lineHeight: 1.55,
        color: "hsl(0 0% 100%)"
      }}>
          Precision tutoring for Calculus, Physics, and SAT Math. Elevate your scores with elite mentorship.
        </p>

        {}
        <p className="font-mono mb-10 inline-block" style={{
        fontSize: "clamp(1.25rem, 1.8vw, 1.75rem)",
        color: "hsl(217 91% 60%)"
      }}>
          Q.E.D. — Your success is calculated.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto">
          <Button asChild className="font-default font-black uppercase tracking-wide text-base md:text-lg px-8 py-7 border-[2px] transition-all duration-200 hover:-translate-y-1" style={{
          backgroundColor: "hsl(217 91% 60%)",
          color: "hsl(0 0% 100%)",
          borderColor: "hsl(217 91% 60%)"
        }}>
            <Link to="/ResourcesPage">
              <Sparkles className="w-5 h-5" strokeWidth={3} />
              DOWNLOAD DIAGNOSTIC
            </Link>
          </Button>

          <Button asChild className="font-default font-black uppercase tracking-wide text-base md:text-lg px-8 py-7 border-[2px] transition-all duration-200 hover:-translate-y-1 bg-transparent" style={{
          color: "hsl(0 0% 100%)",
          borderColor: "hsl(0 0% 100%)"
        }}>
            <Link to="/MasteryTracksPage">
              <Phone className="w-5 h-5" strokeWidth={3} />
              VIEW MASTERY TRACKS
            </Link>
          </Button>
        </div>

        {}
        <p className="font-default font-bold mt-10 text-sm tracking-wide" style={{
        color: "hsl(217 91% 60%)"
      }}>
          1-on-1 Sessions · Digital Whiteboard · Proven Score Gains
        </p>
      </div>
    </section>;
}